// Single source of truth for the canonical origin. Consolidated from the three
// separate `SITE` constants that previously lived in LandingPage.tsx, Blog.tsx,
// and BlogPost.tsx so canonical / og:url values can never drift apart.
export const SITE = "https://veltopb.com";

/**
 * Google Maps embed for the Red Hook venue, shared by the homepage contact
 * section and every landing page's "Visit Velto" block.
 *
 * This is the supported Maps Embed endpoint (`/maps/embed?pb=…`). The landing
 * pages previously used the legacy `/maps?q=…&output=embed` form, which serves
 * a 301 whose response carries `X-Frame-Options: SAMEORIGIN` before redirecting
 * to this same endpoint — an extra hop that privacy extensions and stricter
 * browser settings routinely block, leaving an empty placeholder box. The
 * homepage always used the direct form and always rendered. One constant now,
 * so the two can't drift apart again.
 *
 * The `!1s…` segment is the Google place ID. It previously read
 * `0x89c25a790f8b5c5b:0x5c4b5a0b4b5a0b4b` — a placeholder whose tail is the
 * 3-byte group `4b 5a 0b` repeated, which is not a real CID — so the embed
 * resolved to a bare address pin rather than the Velto listing (fetching the
 * old URL returned "Van Brunt" three times and "Velto" zero times; the current
 * one returns the business). The stale `!4v1703875200000` cache-buster stamp
 * (2023-12-29, predating this repo) is dropped; the endpoint serves the listing
 * without it.
 */
export const MAP_EMBED_URL =
  "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3026.2655041831595!2d-74.00655090304011!3d40.68311176663039!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f35.1!3m3!1m2!1s0x89c25b87d5ae97af%3A0xcef9d2eeaa3641c3!2sVelto%20Pickleball!5e0!3m2!1sen!2sus!5m2!1sen!2sus";
